import { useMemo } from 'react';
import styled from 'styled-components';

import { parse } from '@/utils/marked';

import { Flex } from '../base';

type Props = {
  text: string;
  parseMDtoHTML?: boolean;
};

const InfoBox = (props: Props) => {
  const textHTML = useMemo(() => {
    if (props.parseMDtoHTML) return parse(props.text);
    return props.text;
  }, [props.parseMDtoHTML, props.text]);

  return (
    <Flex a="center" j="center" d="column" className="my-1.5">
      <Style>
        <ContentStyle dangerouslySetInnerHTML={{ __html: textHTML }} />
      </Style>
    </Flex>
  );
};

const Style = styled(Flex).attrs({
  a: 'center',
  j: 'center',
})`
  padding: 2px 8px;
  max-width: 380px;
  border: 1px solid ${(props) => props.theme.colors.gray400};
  border-radius: 16px;
`;

const ContentStyle = styled.div`
  -webkit-user-select: text; /* Safari */
  -khtml-user-select: text;
  -moz-user-select: text;
  -ms-user-select: text; /* Internet explorer */
  user-select: text;
  color: ${(props) => props.theme.colors.gray700};
  font-size: 11px;
  ul,
  ol {
    padding-left: 24px;
  }
  a {
    color: ${(props) => props.theme.colors.primary100};
    text-decoration: underline;
  }
  code {
    font-family: monospace;
    font-weight: 400;
    font-size: 12px;
    padding: 0 4px;
    background-color: ${(props) => props.theme.colors.gray200};
    border: 1px solid ${(props) => props.theme.colors.gray400};
    border-radius: 4px;
    color: ${(props) => props.theme.colors.red600};
  }
  pre {
    display: block;
    width: 80%;
    padding: 4px 8px;
    background-color: ${(props) => props.theme.colors.gray200};
    border-radius: 4px;
    border: 1px solid ${(props) => props.theme.colors.gray400};

    font-weight: 400;
    font-size: 12px;
    line-height: 20px;
    color: ${(props) => props.theme.colors.gray700};
    font-family: monospace;
    code {
      background-color: transparent;
      border: none;
      border-radius: 0;
      color: ${(props) => props.theme.colors.gray700};
    }
  }
  mark {
    background-color: ${(props) => props.theme.colors.mark};
    color: ${(props) => props.theme.colors.gray700};
  }
`;

export default InfoBox;
